import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, Box, TextField, Button, Grid } from '@mui/material';

const MakingOfNoiva = () => {
  const [dados, setDados] = useState({ sala: '', data: '', horario: '', valor: '', observacoes: '' });
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState(false);

  useEffect(() => {
    axios.get('/api/making_of_noiva').then(res => {
      if (res.data && res.data.length > 0) {
        setDados(res.data[0]);
        setId(res.data[0].id);
      }
      setLoading(false);
    });
  }, []);

  const handleChange = e => {
    setDados({ ...dados, [e.target.name]: e.target.value });
  };

  const handleSalvar = async () => {
    if (id) {
      await axios.put(`/api/making_of_noiva/${id}`, dados);
    } else {
      const res = await axios.post('/api/making_of_noiva', dados);
      setId(res.data.id);
    }
    setEditando(false);
  };

  if (loading) return <div>Carregando...</div>;

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Making of da Noiva</Typography>
        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField label="Salão" name="sala" value={dados.sala || ''} onChange={handleChange} fullWidth disabled={!editando} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Data" name="data" type="date" value={dados.data || ''} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} disabled={!editando} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Horário" name="horario" type="time" value={dados.horario || ''} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} disabled={!editando} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Valor" name="valor" type="number" value={dados.valor || ''} onChange={handleChange} fullWidth disabled={!editando} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Observações" name="observacoes" value={dados.observacoes || ''} onChange={handleChange} fullWidth multiline minRows={2} disabled={!editando} />
            </Grid>
          </Grid>
          <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
            {!editando && <Button variant="contained" onClick={() => setEditando(true)}>Editar</Button>}
            {editando && <Button variant="contained" color="primary" onClick={handleSalvar}>Salvar</Button>}
            {editando && <Button variant="outlined" color="secondary" onClick={() => setEditando(false)}>Cancelar</Button>}
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default MakingOfNoiva;
